import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Nav() {
  const { pathname } = useLocation();
  const base = pathname === "/" ? "" : "/";
  const [open, setOpen] = useState(false);

  const links = [
    { href: `${base}#focus`, label: "PILLARS", testid: "nav-link-pillars" },
    { href: `${base}#meetups`, label: "FORMAT", testid: "nav-link-format" },
    { href: `${base}#vision`, label: "2027 VISION", testid: "nav-link-vision" },
    { to: "/founders", label: "FOUNDERS", testid: "nav-link-founders", active: pathname === "/founders" },
    { to: "/blog", label: "DISPATCH", testid: "nav-link-blog", active: pathname.startsWith("/blog") },
    { href: `${base}#apply`, label: "CRITERIA", testid: "nav-link-criteria" },
  ];

  const renderLink = (l, mobile = false) => {
    const cls = `${mobile ? "block py-3 text-sm border-b border-slate-100" : ""} font-mono-lbl ${mobile ? "" : "text-xs"} tracking-widest ${l.active ? "text-aix-cyandeep" : "text-slate-500"} hover:text-aix-cyandeep transition-colors`;
    const tid = mobile ? `mobile-${l.testid}` : l.testid;
    return l.to ? (
      <Link key={l.label} to={l.to} className={cls} data-testid={tid} onClick={() => setOpen(false)}>
        {l.label}
      </Link>
    ) : (
      <a key={l.label} href={l.href} className={cls} data-testid={tid} onClick={() => setOpen(false)}>
        {l.label}
      </a>
    );
  };

  return (
    <header
      className="border-b border-slate-200 bg-white/80 backdrop-blur-md sticky top-0 z-40"
      data-testid="main-nav"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
        <Link
          to="/"
          className="flex flex-col items-start gap-0.5 group"
          data-testid="brand-logo-link"
        >
          <img
            src="/assets/aix-mark.png"
            alt="AI Advantage Exchange (AIX) logo"
            className="h-9 md:h-10 w-auto"
            data-testid="brand-logo-image"
          />
          <span className="font-mono-lbl text-[8px] md:text-[9px] text-slate-400 tracking-[0.14em] md:tracking-[0.18em] uppercase whitespace-nowrap" data-testid="brand-tagline">
            Curated Peer Network • Everywhere
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">{links.map((l) => renderLink(l))}</nav>

        <div className="flex items-center gap-3">
          <a
            href={`${base}#apply`}
            className="bg-aix-navy hover:bg-[#16407F] text-white text-xs font-semibold px-4 py-2 rounded transition-transform active:scale-95 shadow-[0_0_20px_rgba(42,174,228,0.35)]"
            data-testid="join-waitlist-cta"
          >
            Join Waitlist
          </a>
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-slate-700 border border-slate-200 rounded"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="mobile-menu-button"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-slate-200 bg-white px-6 py-2" data-testid="mobile-menu">
          {links.map((l) => renderLink(l, true))}
        </nav>
      )}
    </header>
  );
}
